import React from "react";
import styles from "./Chip.module.scss";

export default function Chip({
  active,
  title,
  classNameChip,
  classNameChipActive,
  classNameChipDisabled,
  classNameLabel,
}) {
  return (
    <div className={`${styles.container} ${classNameChip}`}>
      <div
        className={
          active
            ? `${styles.active} ${classNameChipActive}`
            : `${styles.disabled} ${classNameChipDisabled}`
        }
      >
        <label className={classNameLabel}>{title}</label>
      </div>
    </div>
  );
}
